import {AfterViewInit, Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {ConciliacionService} from "../../core/conciliacion/conciliacion.service";
import {ConciliacionData} from "../../core/conciliacion/conciliacion-data";
import {ConciliacionDataRequest} from "../../core/conciliacion/conciliacion-data-request";
import {PagerService} from "../../core/pagination/pager.service";
import * as moment from 'moment';
import {ConciliacionCsvRequest} from "../../core/conciliacion/conciliacion-csv-request";
import { MessageService } from "primeng/components/common/messageservice";

declare var $: any;

@Component({
  selector: 'app-conciliacion-table',
  templateUrl: './conciliacion-table.component.html',
  styleUrls: ['./conciliacion-table.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConciliacionTableComponent implements OnInit {
  @Input() game: string;

  loading = true;
  maxDateValue = moment().subtract(1, 'days').toDate();

  error = false;
  errorMessage = "";

  currentPage = 0;
  pages = [0, 1, 2, 3, 4];

  isFirstPage = true;
  isLastPage = true;
  lastPage;
  pager = {
    totalItems: 0,
    currentPage: 0,
    pageSize: 0,
    totalPages: 0,
    startPage: 0,
    endPage: 0,
    startIndex: 0,
    endIndex: 0,
    pages: 0
  };
  conciliacionData: Array<ConciliacionData> = [];

  conciliaiconDate = this.maxDateValue;

  private games = {
    melate: ['200', '201', '202'],
    melateretro: ['300'],
    tris: ['221', '222', '223', '224', '225', '226', '227'],
    chispazo: ['280'],
    progol: ['240', '241'],
    progolms: ['250'],
  };

  constructor(protected conciliacionService: ConciliacionService, private pagerService: PagerService, private messageService: MessageService) {
  }

  ngOnInit() {
    console.log("ConciliacionTableComponent#conciliaiconDate", this.getconciliacionDate());
    this.requestData(this.getconciliacionDate(), 0, 10);
  }

  private getconciliacionDate() {
    return moment(this.conciliaiconDate).format("YYYY-MM-DD");
  }

  selecPage(page: number) {
    this.loading = true;
    this.requestData(this.getconciliacionDate(), page - 1, 10);
  }

  nextPage() {
    this.loading = true;
    this.requestData(this.getconciliacionDate(), this.currentPage + 1, 10);
  }

  goToFirstPage() {
    this.loading = true;
    this.requestData(this.getconciliacionDate(), 0, 10);
  }

  private requestData(fecha, page, pageSize) {
    this.error = false;
    const conciliacionDataRequest = new ConciliacionDataRequest(this.games[this.game], fecha, page, pageSize);
    this.conciliacionService.getDataFor(conciliacionDataRequest).finally(() => {
      this.loading = false;
    }).subscribe((response) => {
      this.conciliacionData = response.content;
      this.currentPage = response.number;
      this.isFirstPage = response.first;
      this.isLastPage = response.last;
      this.lastPage = response.totalPages;
      this.pager = this.pagerService.getPager(response.totalElements, response.number, response.size);
    }, (err) => {
      this.error = true;
      this.errorMessage = err;
      console.log("ConciliacionTableComponent#ngOnInit", err);
    });
  }

  prevPage() {
    this.loading = true;
    this.requestData(this.getconciliacionDate(), this.currentPage - 1, 10);
  }

  goToLastPage() {
    this.loading = true;
    this.requestData(this.getconciliacionDate(), this.lastPage - 1, 10);
  }

  selectedDate() {
    this.requestData(this.getconciliacionDate(), 0, 10);
  }

  downloadCsv() {
    const nameDownload = `${this.game}-${this.getconciliacionDate()}.csv`;
    const conciliacionCsvRequest = new ConciliacionCsvRequest(this.games[this.game], this.getconciliacionDate());
    const openedWindow = window.open();
    this.conciliacionService.downloadCsv(conciliacionCsvRequest).subscribe((response) => {
      const url = window.URL.createObjectURL(response); // <-- work with blob directly

      // create hidden dom element (so it works in all browsers)
      const a = document.createElement('a');
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);

      // create file, attach to hidden element and open hidden element
      a.href = url;
      a.download = nameDownload;
      a.click();
    },
      error => {
        console.error(error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error
        });
      });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/conciliacion/conciliacion-table.component.ts